"use strict";

exports.__esModule = true;
exports.VerticalSpacer = exports.HorizontalSpacer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  width: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var HorizontalSpacer = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.height || "1rem";
});

exports.HorizontalSpacer = HorizontalSpacer;

var VerticalSpacer = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.width || "2rem";
});

exports.VerticalSpacer = VerticalSpacer;